import React from 'react';
import { Table, Empty, Tag } from 'antd';
import './styles.css';

export default function MovimientoTable(props) {
    return (
        <Table
            className={'logistica-table-kardex-movimiento'}
            scroll={{ x: true }}
            size="small"
            style={{ overflowX: 'auto' }}
            pagination={false}
            dataSource={props.dataSource}
            rowKey={record => record.id}
            locale={{
                emptyText: <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description='No se encontraron datos.'
                />
            }}
            columns={[
                {
                    title: 'N° Movimiento',
                    dataIndex: 'nroMovimiento',
                    key: 'nroMovimiento',
                    render: (data, item) => (
                        <span>{item.abreviaturaTipoMovimiento === "" ? "" : (item.abreviaturaTipoMovimiento + '-' + item.numeroMovimiento)}</span>
                    )
                },
                {
                    title: 'N° Lote',
                    dataIndex: 'numeroLote',
                    key: 'numeroLote',
                    className: 'child-group'
                },
                {
                    title: 'Documento de Traslado, Comprobante de Pago, Documento Interno o Similar',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Fecha',
                            dataIndex: 'fechaReferencia',
                            key: 'fechaReferencia',
                            className: 'child-group'
                        },
                        {
                            title: 'Tipo',
                            dataIndex: 'codigoTipoComprobanteSunatReferencia',
                            key: 'codigoTipoComprobanteSunatReferencia',
                            className: 'child-group'
                        },
                        {
                            title: 'Serie',
                            dataIndex: 'serieReferencia',
                            key: 'serieReferencia',
                            className: 'child-group'
                        },
                        {
                            title: 'Número',
                            dataIndex: 'documentoReferencia',
                            key: 'documentoReferencia',
                            className: 'child-group'
                        }
                    ]
                },
                {
                    title: 'Entidad',
                    dataIndex: 'entidad',
                    key: 'entidad',
                    className: 'child-group'
                },
                {
                    title: 'Tipo de Operación',
                    dataIndex: 'concepto',
                    key: 'concepto',
                    className: 'child-group'
                },
                {
                    title: 'Ingresos',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Cantidad',
                            dataIndex: 'ingresoCantidad',
                            key: 'ingresoCantidad',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Costo Unitario',
                            dataIndex: 'ingresoCostoUnitario',
                            key: 'ingresoCostoUnitario',
                            align: 'right',
                            className: 'child-group',
                            render: (data, item) => (
                                <span>{item.flagRowTotal ? "" : data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Costo Total',
                            dataIndex: 'ingresoCostoTotal',
                            key: 'ingresoCostoTotal',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        }
                    ]
                },

                {
                    title: 'Salidas',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Cantidad',
                            dataIndex: 'salidaCantidad',
                            key: 'salidaCantidad',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Costo Unitario',
                            dataIndex: 'salidaCostoUnitario',
                            key: 'salidaCostoUnitario',
                            align: 'right',
                            className: 'child-group',
                            render: (data, item) => (
                                <span>{item.flagRowTotal ? "" : data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Costo Total',
                            dataIndex: 'salidaCostoTotal',
                            key: 'salidaCostoTotal',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        }
                    ]
                },

                {
                    title: 'Saldo Final',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Cantidad',
                            dataIndex: 'saldoFinalCantidad',
                            key: 'saldoFinalCantidad',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Costo Unitario',
                            dataIndex: 'saldoFinalCostoUnitario',
                            key: 'saldoFinalCostoUnitario',
                            align: 'right',
                            className: 'child-group',
                            render: (data, item) => (
                                <span>{item.flagRowTotal ? "" : data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Costo Total',
                            dataIndex: 'saldoFinalCostoTotal',
                            key: 'saldoFinalCostoTotal',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        }
                    ]
                },
                {
                    title: 'Precio Promedio',
                    dataIndex: 'precioPromedio',
                    key: 'precioPromedio',
                    align: 'right',
                    className: 'child-group',
                    render: (data, item) => (
                        <span>{item.flagRowTotal ? "" : data.toFixed(3)}</span>
                    )
                },
            ]}
        />
    );
}